import { render, staticRenderFns } from "./SubscriptionBox.vue?vue&type=template&id=7cb3aea0&scoped=true"
import script from "./SubscriptionBox.vue?vue&type=script&lang=ts"
export * from "./SubscriptionBox.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionBox.vue?vue&type=style&index=0&id=7cb3aea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb3aea0",
  null
  
)

export default component.exports